import { useCallbackRef } from '@web/walter-ui-kit'
import { useAuth } from '@web/walter-lib/auth'
import { useModal } from '~contexts/ModalsContext'
import { ModalTypes } from '~contexts/ModalsContext/types'

export const useAuthGuard = <T extends (...args: any[]) => void>(cb: T) => {
    const { isAuth } = useAuth()
    const { show: showAuthRequiredModal } = useModal(ModalTypes.authRequired)
    return useCallbackRef((...args: Parameters<T>) => {
        if (isAuth) {
            cb(...args)
        } else {
            showAuthRequiredModal()
        }
    })
}
